import React from 'react';
import PropTypes from 'prop-types';

const Plus03 = ({color = 'currentColor', ...props}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 1L5 9M9 5L1 5"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

Plus03.propTypes = {
  color: PropTypes.string,
};

export default Plus03;
